var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='-\n&nbsp; <!-- nbsp to force cell height -->\n';
}
return __p;
};
